import useGet from "./useGet";
import {
  generalAPIDefaultInputOptions,
  GeneralAPI,
} from "../../utils/generalApi";

export default function useGeneralAPI(
  modelName,
  inputOptions = generalAPIDefaultInputOptions,
  queryProps = {
    enabled: true,
  }
) {
  const generalAPI = new GeneralAPI(modelName, inputOptions);
  return useGet(generalAPI.getPath(), {
    params: generalAPI.getParams(),
    ...queryProps,
  });
}
